import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitAudit = (data) => axios.post(`${API}/leads/audit`, data);
export const submitChecklist = (data) => axios.post(`${API}/leads/checklist`, data);
export const submitWebinar = (data) => axios.post(`${API}/leads/webinar`, data);
export const checklistDownloadUrl = `${API}/checklist/download`;

export const scrollToId = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const getCohort = () => axios.get(`${API}/cohort`);
export const adminLogin = (email, password) => axios.post(`${API}/auth/login`, { email, password });
export const getLeads = (token) =>
  axios.get(`${API}/leads`, { headers: { Authorization: `Bearer ${token}` } });
export const exportLeadsUrl = `${API}/leads/export`;
